import React from 'react';
import { BarChart, Link, QrCode, FileText, TrendingUp } from 'lucide-react';

/**
 * Компонент боковой панели со статистикой использования
 */
const StatisticsSidebar = ({ stats }) => {
  if (!stats || (stats.totalGeneratedLinks === 0 && stats.totalCopiedLinks === 0 && stats.totalQrCodesDownloaded === 0)) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <BarChart className="w-5 h-5 mr-2 text-indigo-500" />
        Статистика использования
      </h3>

      <div className="grid grid-cols-2 gap-3">
        {/* Количество сгенерированных ссылок */}
        <div className="bg-indigo-50 dark:bg-indigo-900/20 rounded-lg p-3 border border-indigo-100 dark:border-indigo-800">
          <div className="flex items-center mb-1">
            <Link className="w-4 h-4 text-indigo-500 mr-2" />
            <span className="text-xs font-medium text-indigo-600 dark:text-indigo-400">
              Создано ссылок
            </span>
          </div>
          <div className="text-xl font-bold text-indigo-700 dark:text-indigo-300">
            {stats.totalGeneratedLinks}
          </div>
        </div>

        {/* Количество скопированных ссылок */}
        <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-3 border border-green-100 dark:border-green-800">
          <div className="flex items-center mb-1">
            <TrendingUp className="w-4 h-4 text-green-500 mr-2" />
            <span className="text-xs font-medium text-green-600 dark:text-green-400">
              Скопировано
            </span>
          </div>
          <div className="text-xl font-bold text-green-700 dark:text-green-300">
            {stats.totalCopiedLinks}
          </div>
        </div>

        {/* Количество скачанных QR-кодов */}
        <div className="bg-purple-50 dark:bg-purple-900/20 rounded-lg p-3 border border-purple-100 dark:border-purple-800">
          <div className="flex items-center mb-1">
            <QrCode className="w-4 h-4 text-purple-500 mr-2" />
            <span className="text-xs font-medium text-purple-600 dark:text-purple-400">
              QR-кодов скачано
            </span>
          </div>
          <div className="text-xl font-bold text-purple-700 dark:text-purple-300">
            {stats.totalQrCodesDownloaded}
          </div>
        </div>

        {/* Количество сохраненных шаблонов */}
        <div className="bg-amber-50 dark:bg-amber-900/20 rounded-lg p-3 border border-amber-100 dark:border-amber-800">
          <div className="flex items-center mb-1">
            <FileText className="w-4 h-4 text-amber-500 mr-2" />
            <span className="text-xs font-medium text-amber-600 dark:text-amber-400">
              Популярный шаблон
            </span>
          </div>
          <div className="text-sm font-bold text-amber-700 dark:text-amber-300 truncate">
            {stats.mostUsedTemplate || "Не определен"}
          </div>
        </div>
      </div>

      <div className="mt-3 text-xs text-gray-500 dark:text-gray-400">
        <p>Статистика собирается только на вашем устройстве и нигде не сохраняется.</p>
      </div>
    </div>
  );
};

export default StatisticsSidebar;